import styled from 'styled-components';

export const ButtonMenuStyled = styled.button`
  border: none;
  height: 24px;

  display: flex;
  flex-direction: row;
  align-items: center;

  font-size: 14px/18px;
  font-family: Source Sans Pro;
  text-align: left;
  padding: 0;
  margin: 5px 0;
  background-color: var(--color-white);
  color: var(--color-gray-100);

  div {
    width: 100%;
    display: flex;
    align-items: center;
    height: 25px;
    cursor: pointer;
  }

  span {
    margin-left: 13px;
    cursor: pointer;
  }
`;
